import styled from '@emotion/styled'

export const StyledAnchor = styled('a')(({theme}) => ({
  color: theme.palette.hpPrimaryDark,
  cursor: 'pointer',
  textDecoration: 'underline'
}))
